export const actionTypes = {
    SET_MEDIA_SPEND_DATA: 'SET_MEDIA_SPEND_DATA',
    SET_MEDIA_SPEND_CANCEL_TOKEN: 'SET_MEDIA_SPEND_CANCEL_TOKEN',
    IS_MEDIA_SPEND_FETCHING: 'IS_MEDIA_SPEND_FETCHING'
}